"use client"

import type React from "react"

interface EmailFormProps {
  email: string
  subject: string
  body: string
  onEmailChange: (email: string) => void
  onSubjectChange: (subject: string) => void
  onBodyChange: (body: string) => void
}

const EmailForm: React.FC<EmailFormProps> = ({
  email,
  subject,
  body,
  onEmailChange,
  onSubjectChange,
  onBodyChange,
}) => {
  return (
    <div className="form-group">
      <label htmlFor="email-input">Email Address:</label>
      <input
        id="email-input"
        type="email"
        value={email}
        onChange={(e) => onEmailChange(e.target.value)}
        placeholder="recipient@example.com"
        className="text-input"
      />

      <label htmlFor="subject-input">Subject:</label>
      <input
        id="subject-input"
        type="text"
        value={subject}
        onChange={(e) => onSubjectChange(e.target.value)}
        placeholder="Email subject"
        className="text-input"
      />

      <label htmlFor="body-input">Message:</label>
      <textarea
        id="body-input"
        value={body}
        onChange={(e) => onBodyChange(e.target.value)}
        placeholder="Email body"
        className="text-input text-area"
        rows={3}
      />
    </div>
  )
}

export default EmailForm
